import { useTranslation } from "react-i18next";
import { useFormatPrice } from "@hooks/useFormatPrice";
import { type PricePeriodType } from "@services/additional-services/types";

export const useFormatPricePeriod = (
  price: number,
  periodType: PricePeriodType,
): string => {
  const { t } = useTranslation();
  const p = useFormatPrice(price);

  return periodType ? `${p}/${t(`common.pricePeriod.${periodType}.short`)}` : p;
};
